import React from 'react';
import './Card.css'; // Make sure to import your CSS file
import ScrollEffect from './ScrollEffect';
const Card = ({ image, title, description1, description2, isProject }) => {
  return (
    <ScrollEffect fadeType="fade-up">

    
    <div className="card">
      <img src={image} className="card-image" />
      <h3 className="card-title">{title}</h3>
      
     
     

      {/* Show hover content for services */}
      {!isProject && (
        <>
         <p className="card-description">{description1}</p>
          <div className="card-hover-content">
          <p className="card-hover-description">{description2}</p>
        </div>
        </>
      )}

      {/* Show both descriptions on hover for projects */}
      {isProject && (
        <div className="card-hover-content1">
          
          <p className="card-hover-description1">{description2}</p>
          <p className=" card-description1">{description1}</p>
        </div>
      )}
    </div>
    </ScrollEffect>
  );
};

export default Card;